import React, { useState, useRef } from "react";
import { Container, Row, Col, Button, Card, CardBody } from 'react-bootstrap';
import { formatDurationAndTime } from "../../Common/appHelper";

const VehicleListView = ({handleAction, vehicleData}) => {

  return (<Container fluid className="vehicle-container">

     <div className="vehicle-list-top">
          <div className="vehicle-list-innerdiv">
            <Card>
              <CardBody>
                <div className="vehicle-list-hd">
                    <h6>Vehicle Activity</h6> <span onClick={() => handleAction('close')}><i className="bx bx-x"></i></span>
                </div>
                <div className="vehicle-list-body">
                  {(vehicleData && (Object.keys(vehicleData).length>0)) ? vehicleData.map((vehicleObj, indx) => {
                    let vehicleTypeCls = '';
                    if(vehicleObj.type === 'Bike') {
                        vehicleTypeCls = 'vehicle-typ1';
                    } else if(vehicleObj.type === 'Car') {
                        vehicleTypeCls = 'vehicle-typ2';
                    } else if(vehicleObj.type === 'Truck') {
                        vehicleTypeCls = 'vehicle-typ3';    
                    }

                    const inTime = vehicleObj.in_time ?? '';
                    const outTime = vehicleObj.out_time ?? '';
                    const durationArr = formatDurationAndTime(inTime,outTime);

                    const fuelValue = (vehicleObj.fuel_quantity_litre) ? `(${vehicleObj.fuel_quantity_litre} L)` : '';
                    const amount = (vehicleObj.amount) ? `₹ ${vehicleObj.amount}` : '';
                    const paymentType = (vehicleObj.payment_type) ? `(${vehicleObj.payment_type})` : '';
                    
                    return (<Row>
                            <Col md={6}>
                                  <div className="vehicle-bsc-info"><span className="vehicle-nmbr-txt">{vehicleObj?.vehicle_no}</span> <span className="sbl-txt">|</span> <span className="vehicle-modl-txt">{vehicleObj?.model}</span> <span className={`vehicle-typ-txt ${vehicleTypeCls}`}>{vehicleObj.type}</span></div>
                                  <p className="user-bsc-info"><span><i className="bx bx-user"></i></span> {vehicleObj?.owner_name}</p>
                            </Col>
                            <Col md={6}>
                                  <div className="vehicle-time-info"><span><i className="bx bx-time"></i></span> {durationArr.minstext} ({durationArr.timestrng})</div>
                                  <p className="fuval-bsc-info">{(vehicleObj?.fuel || amount || paymentType) && <>{vehicleObj?.fuel} {fuelValue} | {amount} {paymentType}</>}</p>
                            </Col>
                          </Row>);
                  }) : <div className="no-vehicle-found-main"> 
                            <p className="no-vehicle-found"> No Vehicles Found!... </p>
                  </div>}
                </div>
              </CardBody>
            </Card>
          </div>
     </div>
      
  </Container>);
};

export default VehicleListView;
